import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Eex from './Eex';
import Limits from './Limits';
import ClientHardLimit from './ClientHardLimit';

export default function EexTab() {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    display: 'flex',
                    justifyContent: 'space-between'
                }}
            >
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="EEX navigation tabs"
                    role="navigation"
                    sx={{
                        background: '#fff',
                        color: 'white',
                        borderRadius: '5px',
                        padding: '5px',
                        margin: '0 0 10px 10px',
                        boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
                        minHeight: '45px',
                        '& .MuiTabs-indicator': {
                            display: 'none'
                        },
                        '& .MuiTab-root': {
                            minHeight: '35px',
                            height: '35px',
                            '&.Mui-selected': {
                                color: '#3AACFE',
                                background: '#DFF2FF',
                                borderRadius: '5px',
                                borderBottom: 'none'
                            }
                        }
                    }}
                >
                    <Tab label="Prices" aria-label="View EEX prices" />
                    <Tab label="Limits" aria-label="View EEX limits" />
                    <Tab
                        label="Client Hard Limit"
                        aria-label="View EEX hard limits"
                    />
                </Tabs>
            </Box>
            <Box sx={{ padding: '10px' }}>
                {value === 0 && <Eex />}
                {value === 1 && <Limits />}
                {value === 2 && <ClientHardLimit />}
            </Box>
        </Box>
    );
}
